import { Reasons } from '../styles';

/** Причины пометки «проверить», пока строку не проверили. */
export function ReviewReasons({ reasons }: { reasons: string[] }) {
  if (reasons.length === 0) return null;
  return (
    <Reasons aria-label="Почему проверить">
      {reasons.map((s) => (
        <li key={s}>{s}</li>
      ))}
    </Reasons>
  );
}
